import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

const accounts = {
  state: {
    accounts: [],
  },
  mutations: {
    setAccounts(state, val) {
      console.log(val);
      state.accounts = val;
    },
    addPosts(state, val) {
      let i = state.accounts.findIndex((a) => a.id === val.id);
      console.log(val.elements);
      state.accounts[i].feed.elements = state.accounts[i].feed.elements.concat(
        val.elements
      );
      state.accounts[i].feed.paging = val.paging;
      console.log(state.accounts[i]);
    },
    setLoading(state, val) {
      let i = state.accounts.findIndex((a) => a.id === val.id);
      if (i >= 0) {
        state.accounts[i].loading = true;
      }
    },
    setLoadingFalse(state, val) {
      let i = state.accounts.findIndex((a) => a.id === val.id);
      if (i >= 0) {
        state.accounts[i].loading = false;
      }
    },
  },
  actions: {
    async fetchAccounts({ commit }) {
      commit("setLoading", { type: "accounts", val: true });
      try {
        const accountsGet = httpsCallable(functions, "accountsGet");
        console.log("fetching accounts");
        const res = await accountsGet();
        console.log("accounts:");
        console.log(res);
        commit("setAccounts", res.data);
        commit("setLoading", { type: "accounts", val: false });
        return res.data;
      } catch (error) {
        commit("setLoading", { type: "accounts", val: false });
        throw error;
      }
    },
    async loadMore({ commit }, a) {
      const getNextPage = httpsCallable(functions, "getNextPage");
      const res = await getNextPage({
        account: a.id,
        next: a.feed.paging.links.find((l) => l.rel === "next").href,
        platform: a.platform,
      });
      commit("addPosts", { ...a, ...res.data });

      commit("setLoadingFalse", a);
    },
  },
  getters: {},
};

export default accounts;
